module.exports = __webpack_public_path__ + "static/gm-2-781932bffca3a4b968e01d27c31d613b.jpg";